import { removeMenuButtonEvents } from "./menuButton";
export const removeLocalEvents = (state, { onCleanup = false } = {}) => {
    document.removeEventListener("click", state.onClickDocumentRef);
    removeMenuButtonEvents(state, onCleanup);
};
